module.exports = function(
  $q,
  $scope,
  $timeout,
  $location,
  officeResolve,
  OfficeModel,
  Office,
  Notification,
  IndustrySpecific,
  gettextCatalog,
  settings,
  employees,
  MailDA,
  Upload,
) {
  var isBillingVisible = require('t2g.common.isBillingVisible');

  $scope.settingsForm = _.cloneDeep(settings.settingsForm);
  $scope.office = officeResolve;

  if (!isBillingVisible($location)) {
    delete $scope.settingsForm.billingAddress;
    delete $scope.settingsForm.accounting;
  }

  let officeCopy;

  function initBillingAddress() {
    const office = $scope.office;

    officeCopy = _.cloneDeep(office);

    // if user not yet set billing address we can populate it values from public profile values
    if (!office.billingAddress) {
      let firstname;
      let lastname;

      if ($scope.employees && $scope.employees.length != 0) {
        const employee = $scope.employees[0];

        if (employee) {
          firstname = employee.firstname;
          lastname = employee.lastname;
        }
      }

      $scope.office.billingAddress = {
        companyName: office.company,
        firstname,
        lastname,
        city: office.address.city ? office.address.city.name : undefined,
        street: office.address.street,
        postal: office.address.postal,
        country: office.address.country,
      };
    }
  }

  $scope.validateBillingAddress = false;

  $scope.logoPreview = _.get($scope, 'office.profile.logo.url') || undefined;
  var removeLogoPreviewKey = null;

  $scope.currencies = ['EUR', 'CHF', 'EGP'];

  $scope.onFileSelect = function($files) {
    $scope.$files = $files;
    for (var i = 0; i < $scope.$files.length; i++) {
      var file = $scope.$files[i];

      if (window.FileReader && file.type.indexOf('image') > -1) {
        var fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = function(e) {
          $timeout(function() {
            $scope.logoPreview = e.target.result;
          });
        };
      }
    }
  };

  IndustrySpecific.getLabels().then(function(labels) {
    $scope.customersLabel = gettextCatalog.getString(labels.customers.toLowerCase());
  });

  function generateResourceOrder() {
    var alreadySorted = [];
    $scope.employees = [];

    // add sorted resources
    _.forEach($scope.office.settings.resourceOrder, function(employeeId) {
      var employee = _.find(employees, { _id: employeeId });

      if (employee) {
        $scope.employees.push(employee);
      }

      alreadySorted.push(employeeId);
    });

    // add non-sorted resources
    _.forEach(employees, function(employee) {
      if (alreadySorted.indexOf(employee._id) === -1) {
        $scope.employees.push(employee);
        alreadySorted.push(employee._id);
      }
    });
  }

  function getResourceOrder() {
    $scope.office.settings.resourceOrder = _.map($scope.employees, '_id');
  }

  function moveEmployee(index, direction) {
    $scope.employees.move(index, index + direction);
    getResourceOrder();
  }

  $scope.moveEmployeeUp = function(index) {
    if (index >= 1) {
      moveEmployee(index, -1);
    }
  };

  $scope.moveEmployeeDown = function(index) {
    if (index <= $scope.employees.length - 1) {
      moveEmployee(index, 1);
    }
  };

  $scope.slotLengths = [
    { minutes: 60, value: gettextCatalog.getString('Hourly') },
    { minutes: 30, value: gettextCatalog.getString('Every half hour') },
    { minutes: 15, value: gettextCatalog.getString('Every quarter hour') },
    { minutes: 'DYNAMIC_LENGTH', value: gettextCatalog.getString('Dynamic') },
  ];

  if (!$scope.office.settings.dynamicSlotLength) {
    $scope.slotLength = $scope.office.settings.slotLength;
  } else {
    $scope.slotLength = 'DYNAMIC_LENGTH';
  }

  $scope.watchDynamic = function(newValue) {
    $scope.office.settings.dynamicSlotLength = newValue === 'DYNAMIC_LENGTH';

    if ($scope.office.settings.dynamicSlotLength) return;

    $scope.office.settings.slotLength = newValue;
  };

  // generate lead hour values
  $scope.leadTimes = [];
  var leadHours = [
    { hours: 1, value: 0.0416666666666667 },
    { hours: 2, value: 0.0833333333333333 },
    { hours: 3, value: 0.125 },
    { hours: 4, value: 0.1666666666666667 },
    { hours: 6, value: 0.25 },
    { hours: 8, value: 0.3333 },
    { hours: 10, value: 0.4167 },
    { hours: 12, value: 0.5 },
  ];

  var leadDays = [
    { days: 1, value: 1 },
    { days: 2, value: 2 },
    { days: 3, value: 3 },
    { days: 4, value: 4 },
    { days: 5, value: 5 },
    { days: 6, value: 6 },
    { days: 7, value: 7 },
    { days: 10, value: 10 },
  ];

  leadHours.forEach(function(leadHour) {
    $scope.leadTimes.push({
      label: gettextCatalog.getPlural(leadHour.hours, '1 hour', '{{$count}} hours', {}),
      value: leadHour.value,
    });
  });

  leadDays.forEach(function(leadDay) {
    $scope.leadTimes.push({
      label: gettextCatalog.getPlural(leadDay.days, '1 day', '{{$count}} days', {}),
      value: leadDay.value,
    });
  });

  // generate book advance values
  var bookAdvanceTimes = [1, 3, 7, 14, 21, 28, 45, 60, 90, 120, 180];
  $scope.bookAdvanceTimes = [];

  bookAdvanceTimes.forEach(function(bookAdvanceTime) {
    $scope.bookAdvanceTimes.push({
      label: gettextCatalog.getPlural(bookAdvanceTime, '1 day', '{{$count}} days', {}),
      value: bookAdvanceTime,
    });
  });

  // generate accept after values
  var acceptAfterTimes = [1, 2, 3, 6, 12, 24];

  $scope.acceptAfter = [
    {
      label: gettextCatalog.getString('Instant'),
      hours: 0,
    },
    {
      label: gettextCatalog.getString('After half an hour'),
      hours: 0.5,
    },
  ];

  acceptAfterTimes.forEach(function(acceptAfterTime) {
    $scope.acceptAfter.push({
      label: gettextCatalog.getPlural(
        acceptAfterTime,
        'after 1 hour',
        'after {{$count}} hours',
        {},
      ),
      hours: acceptAfterTime,
    });
  });

  $scope.serviceGroupCollapsingSettings = [
    { value: 0, label: gettextCatalog.getString('first group opened (default)') },
    { value: 1, label: gettextCatalog.getString('all expanded') },
    { value: 2, label: gettextCatalog.getString('all collapsed') },
  ];

  $scope.office.settings.widget = $scope.office.settings.widget || {};
  $scope.office.settings.widget.appointment = $scope.office.settings.widget.appointment || {};
  $scope.office.settings.widget.appointment.serviceGroupCollapsing =
    $scope.office.settings.widget.appointment.serviceGroupCollapsing || 0;

  // generate reminder times
  var reminderTimesHours = [
    { hours: 1, value: 3600 },
    { hours: 2, value: 7200 },
    { hours: 3, value: 10800 },
    { hours: 5, value: 18000 },
    { hours: 8, value: 28800 },
    { hours: 12, value: 43200 },
  ];

  var reminderTimesDays = [
    { days: 1, value: 86400 },
    { days: 2, value: 172800 },
    { days: 3, value: 259200 },
    { days: 5, value: 432000 },
    { days: 7, value: 604800 },
  ];

  $scope.reminderTimes = [
    {
      label: gettextCatalog.getString('Day before at 8 p.m'),
      value: -1,
    },
    {
      label: gettextCatalog.getString('30 minutes before'),
      value: 1800,
    },
  ];

  reminderTimesHours.forEach(function(reminderTimesHour) {
    $scope.reminderTimes.push({
      label: gettextCatalog.getPlural(
        reminderTimesHour.hours,
        '1 hour before',
        '{{$count}} hours before',
        {},
      ),
      value: reminderTimesHour.value,
    });
  });

  reminderTimesDays.forEach(function(reminderTimesDay) {
    $scope.reminderTimes.push({
      label: gettextCatalog.getPlural(
        reminderTimesDay.days,
        '1 day before',
        '{{$count}} days before',
        {},
      ),
      value: reminderTimesDay.value,
    });
  });

  // generate cancellation limit values
  var cancellationLimitDays = [
    { days: 2, value: 172800000 },
    { days: 3, value: 259200000 },
    { days: 4, value: 345600000 },
    { days: 5, value: 432000000 },
  ];

  $scope.cancellationLimit = [
    { label: gettextCatalog.getString('always'), value: 0 },
    {
      label: gettextCatalog.getPlural(12, '1 hour before', '{{$count}} hours before', {}),
      value: 43200000,
    },
    {
      label: gettextCatalog.getPlural(24, '1 hour before', '{{$count}} hours before', {}),
      value: 86400000,
    },
  ];

  cancellationLimitDays.forEach(function(cancellationLimitDay) {
    $scope.cancellationLimit.push({
      label: gettextCatalog.getPlural(
        cancellationLimitDay.days,
        '1 day before',
        '{{$count}} days before',
        {},
      ),
      value: cancellationLimitDay.value,
    });
  });

  $scope.maxServices = [1, 2, 3, 4, 5];

  $scope.office.settings.contextMenu = $scope.office.settings.contextMenu || {
    single: { active: true, label: gettextCatalog.getString('Appointment') },
    course: { active: true, label: gettextCatalog.getString('Course') },
    private: { active: true, label: gettextCatalog.getString('Private') },
  };

  $scope.office.settings.cancelLimit = $scope.office.settings.cancelLimit || 0;
  $scope.office.settings.slotLength = $scope.office.settings.slotLength || 15;
  $scope.office.settings.slotStart = $scope.office.settings.slotStart || 60;

  // reminder email time default
  if (!$scope.$eval('office.settings.reminder.email.time')) {
    $scope.$eval('office.settings.reminder.email.time=-1');
  }

  if (!$scope.$eval('office.settings.reminder.sms.time')) {
    $scope.$eval('office.settings.reminder.sms.time=-1');
  }

  // global mail address default
  if (!$scope.$eval('office.settings.email.global.address')) {
    $scope.$eval('office.settings.email.global.address=office.profile.contacts.email');
  }

  // global phone number default
  if (!$scope.$eval('office.settings.sms.phone')) {
    $scope.$eval('office.settings.sms.phone=office.profile.contacts.phone');
  }

  /**
   * @param type
   */
  $scope.reminderChanged = function(type) {
    if ($scope.office.settings.reminder[type].time === -1) {
      $scope.office.settings.reminder[type].dayBefore = true;
    } else {
      $scope.office.settings.reminder[type].dayBefore = false;
    }
  };

  function update() {
    OfficeModel.update($scope.office, function(error) {
      if (error) {
        Notification.addErrorMessage({ text: error });
      } else {
        initBillingAddress();
        $scope.logoPreview = _.get($scope, 'office.profile.logo.url') || undefined;
        $scope.$files = null;
        removeLogoPreviewKey = null;

        Notification.addSuccessMessage(gettextCatalog.getString('Settings saved'));
      }
    });
  }

  $scope.removeLogo = function() {
    removeLogoPreviewKey = _.get($scope, 'office.profile.logo.key') || undefined;

    $scope.office.profile.logo = null;
    $scope.logoPreview = null;
    $scope.$files = null;
  };

  /**
   * save to API
   */
  $scope.save = function() {
    $scope.showValidation = true;

    const isBillingAddressActive = $(document)
      .find('#billingAddress')
      .hasClass('active');

    if (isBillingAddressActive) {
      $scope.validateBillingAddress = true;
    } else {
      // no need to validate if billing address tab is not active
      $scope.validateBillingAddress = false;

      // reset billingAddress state with latest valid state from DB
      $scope.office.billingAddress = officeCopy.billingAddress;
    }

    setTimeout(() => {
      if ($scope.SettingsForm.$valid) {
        // upload logo
        if ($scope.$files) {
          Upload.upload({
            url: '/api/v2/office/uploadLogo',
            data: {},
            file: $scope.$files,
          })
            .progress(function(evt) {
              console.log('upload:' + parseInt((100.0 * evt.loaded) / evt.total));
            })
            .success(function(data) {
              $scope.office.profile.logo = data.logo;
              update();
            })
            .error(function(error) {
              if (error.message === 'file_to_large') {
                Notification.addErrorMessage(
                  gettextCatalog.getString('Image file is to large (max 1.0 MB)'),
                );
              } else if (error.message === 'extension_not_allowed') {
                Notification.addErrorMessage(
                  gettextCatalog.getString('Image file extension not of type [JPG,PNG]'),
                );
              } else {
                Notification.addErrorMessage({ text: error.message });
              }

              update();
            });
        } else if (removeLogoPreviewKey) {
          OfficeModel.removeLogo($scope.office, function(error) {
            if (error) {
              Notification.addErrorMessage({ text: error });
            } else {
              update();
            }
          });
        } else {
          update();
        }
      }
    }, 10);
  };

  $scope.testSMTP = function() {
    $scope.testingSMTP = true;

    if ($scope.areSMTPFieldsValid) {
      MailDA.verifySMTP($scope.office.settings.email.smtp)
        .then(function() {
          $scope.testingSMTP = false;
          Notification.addSuccessMessage(gettextCatalog.getString('Connection OK'));
        })
        .catch(function() {
          $scope.testingSMTP = false;
          Notification.addErrorMessage(
            gettextCatalog.getString(
              'Error: Cant connect to SMTP Server. Please check Settings or contact Support.',
            ),
          );
        });
    }
  };

  $scope.areSMTPFieldsValid = function() {
    return (
      _.get($scope.office.settings, 'email.smtp.from') &&
      _.get($scope.office.settings, 'email.smtp.options.host') &&
      _.get($scope.office.settings, 'email.smtp.options.auth.user') &&
      _.get($scope.office.settings, 'email.smtp.options.auth.pass')
    );
  };

  generateResourceOrder();
  initBillingAddress();
};



// WEBPACK FOOTER //
// ./src/app/modules/settings/settingsCtrl.js